/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getLocationList = (payload, callback) =>
  req.list(
    c.GET_LOCATIONS,
    'api/v1/rpt/administrator/settings/locations',
    payload,
    callback
  );

export const getSingleLocation = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LOCATION,
    `api/v1/rpt/administrator/settings/locations/${id}`,
    payload,
    callback
  );

export const createLocation = (payload, callback) =>
  req.create(
    c.CREATE_LOCATION,
    'api/v1/rpt/administrator/settings/locations',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLocation = (id, payload, callback) =>
  req.update(
    c.UPDATE_LOCATION,
    `api/v1/rpt/administrator/settings/locations/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLocation = (id, payload, callback) =>
  req.remove(
    c.REMOVE_LOCATION,
    `api/v1/rpt/administrator/settings/locations/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

  export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAY_LIST,
    'api/v1/rpt/administrator/settings/barangays',
    payload,
    callback
  );

  export const getDistrictList = (payload, callback) =>
  req.list(
    c.GET_DISTRICT_LIST,
    'api/v1/rpt/administrator/settings/districts',
    payload,
    callback
  );


